"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Component = exports.TaskComponent = exports.TaskViewStore = undefined;

var _defineProperty = require("babel-runtime/core-js/object/define-property");

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _desc, _value, _class, _descriptor, _dec2, _class3, _class4, _temp;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactDom = require("react-dom");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _mobx = require("mobx");

var _mobxReact = require("mobx-react");

var _autoclassDecorator = require("autoclass-decorator");

var _autoclassDecorator2 = _interopRequireDefault(_autoclassDecorator);

var _baseComponent = require("base-component");

var _baseComponent2 = _interopRequireDefault(_baseComponent);

var _baseViewstore = require("base-viewstore");

var _baseViewstore2 = _interopRequireDefault(_baseViewstore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var TaskViewStore = exports.TaskViewStore = (_dec = _mobx.observable.ref, (_class = function (_BaseViewStore) {
  (0, _inherits3.default)(TaskViewStore, _BaseViewStore);

  function TaskViewStore() {
    (0, _classCallCheck3.default)(this, TaskViewStore);

    var _this = (0, _possibleConstructorReturn3.default)(this, (TaskViewStore.__proto__ || (0, _getPrototypeOf2.default)(TaskViewStore)).apply(this, arguments));

    _initDefineProp(_this, "inputStore", _descriptor, _this);

    var _this$props = _this.props,
        task = _this$props.contentModel,
        _this$props$currentVi = _this$props.currentView,
        simDataModel = _this$props$currentVi.dataModel,
        viewMode = _this$props$currentVi.viewMode,
        application = _this$props.application;


    var InputStore = task.activity.InputStore || task.InputStore;

    if (!!simDataModel) {
      _this.inputStore = simDataModel[task.id] || simDataModel.addStore(InputStore);
    } else {
      _this.inputStore = new InputStore({ simgate: application.simgate });
      _this.inputStore.loadData();
    }
    // add reference for sake of any computed input values
    task.activity.$inputStore = _this.inputStore;
    return _this;
  }

  return TaskViewStore;
}(_baseViewstore2.default), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "inputStore", [_dec], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
})), _class));
var TaskComponent = exports.TaskComponent = (_dec2 = (0, _mobxReact.inject)("application"), _dec2(_class3 = (0, _mobxReact.observer)(_class3 = (0, _autoclassDecorator2.default)(_class3 = (_temp = _class4 = function (_BaseComponent) {
  (0, _inherits3.default)(TaskComponent, _BaseComponent);

  function TaskComponent() {
    (0, _classCallCheck3.default)(this, TaskComponent);
    return (0, _possibleConstructorReturn3.default)(this, (TaskComponent.__proto__ || (0, _getPrototypeOf2.default)(TaskComponent)).apply(this, arguments));
  }

  (0, _createClass3.default)(TaskComponent, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          task = _props.contentModel,
          simDataModel = _props.currentView.dataModel;
      var inputStore = this.viewStore.inputStore;


      if (typeof task.activity === "string") {
        return _react2.default.createElement(
          "div",
          null,
          "activity is invalid (",
          task.activity,
          ")",
          _react2.default.createElement("br", null),
          "you are likely missing this component (",
          task.activityType,
          ") from your filesystem"
        );
      }

      var Activity = task.activity && task.activity.Component;

      return !!Activity && _react2.default.createElement(
        _mobxReact.Provider,
        { inputStore: inputStore, dataModel: simDataModel },
        _react2.default.createElement(Activity, {
          inputStore: inputStore,
          dataModel: simDataModel,
          contentModel: task.activity
        })
      );
    }
  }]);
  return TaskComponent;
}(_baseComponent2.default), _class4.ViewStore = TaskViewStore, _temp)) || _class3) || _class3) || _class3);
var Component = exports.Component = TaskComponent;
var _default = Component;
exports.default = _default;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(TaskViewStore, "TaskViewStore", "src/entity_modules/task-entity/component.js");

  __REACT_HOT_LOADER__.register(TaskComponent, "TaskComponent", "src/entity_modules/task-entity/component.js");

  __REACT_HOT_LOADER__.register(Component, "Component", "src/entity_modules/task-entity/component.js");

  __REACT_HOT_LOADER__.register(_default, "default", "src/entity_modules/task-entity/component.js");
}();

;


//////////////////
// WEBPACK FOOTER
// ./~/platform-client-bootstrap/dist/entity_modules/task-entity/component.js
// module id = ./node_modules/platform-client-bootstrap/dist/entity_modules/task-entity/component.js
// module chunks = 0